import { render } from "./Access.vue?vue&type=template&id=0cf87976"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/Access.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf87976"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf87976', __exports__)) {
    console.log('reload')
    api.reload('0cf87976', __exports__)
  }
  
  module.hot.accept("./Access.vue?vue&type=template&id=0cf87976", () => {
    console.log('re-render')
    api.rerender('0cf87976', render)
  })

}


export default __exports__